<div fxLayout="column" fxLayoutGap.gt-sm="8px" fxLayoutGap.lt-md="16px" fxLayoutAlign="space-between center">
  <div *ngIf="(!imageLoaded || !image); else slide">
    <mat-spinner *ngIf="showSpinner" [diameter]="50"></mat-spinner>
  </div>
  <ng-template #slide>
    <div *ngIf="handsetService.isMobile" class="center" style="width: 100%; height: 300px"
         (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)"
         (touchmove)="onTouchMove($event)">
      <img [src]="imageUrl" [style]="imgStyle" [ngStyle]="{ transform: 'translateX(' + translateX + 'px)' }" />
    </div>
    <div *ngIf="!handsetService.isMobile" class="center" style="width: 100%; height: 200px"
         (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)"
         (touchmove)="onTouchMove($event)">
      <img [src]="imageUrl" [style]="imgStyle" [ngStyle]="{ transform: 'translateX(' + translateX + 'px)' }" />
    </div>
    <div *ngIf="handsetService.isMobile" class="slider-container" [ngStyle]="buttonsStyle">
      <div fxLayout="row" fxLayoutGap="5px">
        <button *ngFor="let imageButton of images "
                mat-mini-fab
                [ngClass]="{'selected': (imageButton===image)}"
                color="accent"
                (click)="onSliderButtonClick(imageButton)"
                fxLayoutAlign="center center">
        </button>
      </div>
    </div>
    <h1 [innerHTML]="image.title" [ngStyle]="titleStyle"></h1>
    <p fxFlex.xs='80px' fxFlex.sm='75px' fxFlex.gt-sm='54px'
       [innerHTML]="image.subtitle" [ngStyle]="subtitleStyle"></p>

    <div *ngIf="!handsetService.isMobile" class="slider-container" [ngStyle]="buttonsStyle">
      <div fxLayout="row" fxLayoutGap="5px">
        <button *ngFor="let imageButton of images "
                mat-mini-fab
                [ngClass]="{'selected': (imageButton===image)}"
                color="accent"
                (click)="onSliderButtonClick(imageButton)"
                fxLayoutAlign="center center">
        </button>
      </div>
    </div>
  </ng-template>
</div>
